/**
 * Generate recaptcha token and save it to the form
 */
function generateRecaptchaToken(callback) {
	const recaptchaElement = this.wrapperElement.querySelector('input[name="recaptcha_token"]');

	// If recaptcha has not loaded after 30 seconds then show an error and let them try again.
	let timeoutId = setTimeout(() => {
		const publicError = new Error('Hm, we’re having trouble submitting your quote request... try again?');
		callback([publicError]);
	}, 30000);

	grecaptcha.ready(() => {
		clearTimeout(timeoutId);
		grecaptcha.execute(GS.RECAPTCHA_SITE_KEY_V3, {action: 'quote_request'}).then(token => {
			recaptchaElement.value = token;
			callback();
		});
	});
}

export {
	generateRecaptchaToken
}